<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>商品列表</el-breadcrumb-item> -->
      <el-breadcrumb-item>购物车</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- <el-page-header
      @back="goBack"
      class="mt-20"
      title="商品列表"
      content="我的购物车"
    >
    </el-page-header> -->

    <div class="panel mt-20">
      <el-table
        v-if="!isMobile()"
        :data="list"
        stripe
        style="width: 100%"
        @selection-change="handleSelectionChange"
        ref="cartTable"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selectTable"
        ></el-table-column>
        <el-table-column align="left" label="商品" min-width="200px">
          <template slot-scope="scope">
            <div class="item-container">
              <div class="flex-row">
                <auth-img
                  tag="el-image"
                  :src="scope.row.commodity.cover"
                  style="width: 84px; height: 84px"
                  fit="cover"
                  ><div slot="error" class="image-slot">暂无图片</div></auth-img
                >
              </div>
              <div class="item-info">
                <div class="part-number">
                  {{ scope.row.commodity.part_number
                  }}<span class="font-12">
                    （{{
                      scope.row.commodity.type == 1 ? '备件' : '服务'
                    }}）</span
                  >
                  <el-tag
                    size="mini"
                    type="danger"
                    effect="dark"
                    v-if="
                      scope.row.commodity.status != 0 &&
                      scope.row.promotion_id > 0
                    "
                    >促销</el-tag
                  >
                  <em class="text-danger font-12" style="font-style: normal">
                    {{
                      scope.row.commodity.status == 0 ? '（此商品已下架）' : ''
                    }}</em
                  >
                </div>
                <span>
                  <el-tag size="mini">{{
                    scope.row.commodity.commodity_category.name
                  }}</el-tag>
                </span>
                <!-- <span>{{ scope.row.commodity.part_number }}</span> -->
                <span class="item-desc"
                  >{{ scope.row.commodity.description }}
                  {{ scope.row.commodity.description_zh }}</span
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          align="center"
          prop="commodity.part_number"
          label="件号"
        ></el-table-column> -->
        <!-- <el-table-column
          align="center"
          prop="commodity.commodity_category.name"
          label="分类"
        ></el-table-column> -->
        <el-table-column align="center" label="单价（元）">
          <template slot-scope="scope">{{
            scope.row.commodity.dealer_price.toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column align="center" label="数量" width="200">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.number"
              :step="1"
              :min="1"
              :max="100000"
              step-strictly
              size="mini"
              @change="
                (val) => {
                  cartNumberChange(val, scope.row)
                }
              "
            ></el-input-number>
          </template>
        </el-table-column>

        <el-table-column align="center" label="小计（元）">
          <template slot-scope="scope">
            ￥{{
              (scope.row.number * scope.row.commodity.dealer_price).toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <el-popconfirm
              :title="`确认删除吗？`"
              @confirm="handleDelete(scope.row, scope.$index)"
            >
              <el-button slot="reference" type="text" size="mini"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div class="option-bar">
        <div class="optipn-left">
          <el-checkbox v-model="selectedAll" @change="handleSelectedAllChange"
            >全选</el-checkbox
          >
          <span class="ml-10 font-12 pointer" @click="handleDeleteSelected"
            >删除选中的商品</span
          >
        </div>
        <div class="optipn-fight">
          <span
            >已选择
            <b style="color: #e4393c">{{ selectedInfo.count }}</b> 件商品</span
          >
          <span class="ml-20">合计未税：￥{{ selectedInfo.noTaxPrice }}</span>
          <span class="ml-20">合计税费：￥{{ selectedInfo.taxPrice }}</span>
          <span class="ml-20"
            >合计含税：<b class="pay-amount"
              >￥{{ selectedInfo.totalPrice }}</b
            ></span
          >
          <el-button type="danger" class="ml-20" @click="goToSettle"
            >去结算</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  cartList,
  updateCart,
  deleteCart,
  changeCartStatus,
} from '@/service/getData'
import { isMobile } from '../../../util'

export default {
  data() {
    return {
      selectedAll: false,
      tableRendered: false,
      isMobile,
      list: [],
    }
  },
  created() {
    this.getData()
  },
  computed: {
    selectedInfo() {
      let res = {
        count: 0,
        noTaxPrice: 0,
        taxPrice: 0,
        totalPrice: 0,
      }
      this.list
        .filter((item) => item.selected)
        .map((item) => {
          res.count += item.number
          res.noTaxPrice += item.number * item.commodity.dealer_price
        })
      res.taxPrice = (res.noTaxPrice * 0.13).toFixed(2)
      res.totalPrice = (res.noTaxPrice + Number(res.taxPrice)).toFixed(2)
      res.noTaxPrice = res.noTaxPrice.toFixed(2)
      return res
    },

    cartSelectableLength() {
      return this.list.filter((item) => item.commodity.status == 1).length
    },
  },
  methods: {
    async getData() {
      let res = await cartList({})
      this.list = res.data.list.map((item) => {
        item.selected = item.status == 1
        return item
      })

      this.$nextTick(() => {
        this.list.map((item, index) => {
          if (item.selected) {
            this.$refs.cartTable.toggleRowSelection(item, true)
          }
        })

        if (
          this.list.filter((it) => it.selected).length ==
            this.cartSelectableLength &&
          this.cartSelectableLength > 0
        ) {
          this.selectedAll = true
        }
        this.tableRendered = true
      })
    },
    selectTable(row, index) {
      return row.commodity.status == 1
    },
    handleSelectedAllChange(val) {
      if (val) {
        this.$refs.cartTable.toggleAllSelection()
      } else {
        this.$refs.cartTable.clearSelection()
      }
    },
    async handleSelectionChange(items) {
      if (!this.tableRendered) return
      this.list.map((item) => {
        if (items.filter((it) => it.id == item.id).length > 0) {
          item.selected = true
        } else {
          item.selected = false
        }
      })

      this.selectedAll =
        items.length == this.cartSelectableLength &&
        this.cartSelectableLength > 0

      // 更新选中状态
      let selectedIDs = items.map((item) => {
        return item.id
      })
      await changeCartStatus({ ids: selectedIDs })
    },
    async cartNumberChange(v, item) {
      await updateCart(item)
    },

    handleDeleteSelected() {
      let ids = this.list
        .filter((item) => item.selected)
        .map((item) => {
          return item.id
        })
      if (ids.length == 0) {
        this.$alert('请至少选中一件商品')
        return
      } else {
        this.$confirm('确认删除选中商品嘛?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await deleteCart({ ids: ids })
            if (res.code == 0) {
              this.list = this.list.filter((item) => !item.selected)
            }
          })
          .catch(() => {})
      }
    },
    async handleDelete(item, index) {
      let res = await deleteCart({ ids: [item.id] })
      if (res.code == 0) {
        this.list.splice(index, 1)
        if (
          this.list.filter((it) => it.selected).length ==
            this.cartSelectableLength &&
          this.cartSelectableLength > 0
        ) {
          this.selectedAll = true
        }
        this.$emit('updateGoingCount')
      }
    },

    goToSettle() {
      if (this.list.filter((item) => item.selected).length == 0) {
        this.$alert('请至少选中一件商品')
        return
      }

      let promotionItems = this.list.filter(
        (item) =>
          item.selected &&
          item.promotion_id > 0 &&
          item.promotion_total > 0 &&
          item.number > item.promotion_left
      )
      if (promotionItems.length > 0) {
        this.$alert(
          `促销商品 ${promotionItems[0].commodity.part_number} 剩余可购数量为 ${promotionItems[0].promotion_left}`
        )
        return
      }
      if (Number(this.selectedInfo.totalPrice) < 4000) {
        this.$alert('订单总价低于 4000元 无法创建订单！', '温馨提示')
        return
      }
      this.$router.push('/dashboard/shop/orders/confirm')
    },
    goBack() {
      this.$router.push('/dashboard/shop/commodities')
    },
  },
}
</script>

<style scoped>
.pay-amount {
  color: #e4393c;
  font-size: 1.2em;
  font-weight: bold;
}

.item-container {
  display: flex;
  align-content: flex-start;
}
.item-info {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.optipn-left {
  padding-left: 14px;
}
.option-bar {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.item-desc {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 36px;
  font-size: 12px;
  color: #666;
  line-height: 1.4em;
  margin-top: 4px;
}
.part-number {
  color: #3d3d3d;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  display: flex;
  align-items: center;
}
</style>